export const enum CursorType {
    POINTER = 'pointer',
    DEFAULT = 'default'
}